import { connect } from 'react-redux';
import React from 'react';

import { LOGGED_IN } from '../constants';
import * as c from '../constants';
import ActionButton from './ActionButton';

/**
 * HOC which makes sure that the user is LOGGED_IN before rendering
 * If they are not logged in then it shows a 'Not logged in' message.
 */
function requireLogin(Component) {
  class HOC extends React.Component {
    render() {
      const {status, onLogin} = this.props;

      if (status !== LOGGED_IN) {
        return <span>Not logged in: <ActionButton onClick={onLogin}>Login</ActionButton></span>
      }

      return <Component {...this.props} />
    }
  }

  const mapStateToProps = state => {
    return {
      status: state.authentication.status
    }
  }

  const mapDispatchToProps = dispatch => {
    return {
      onLogin: () => dispatch({ type: c.LOGIN })
    }
  }

  return connect(mapStateToProps, mapDispatchToProps)(HOC);
}

export default requireLogin;


/** WEBPACK FOOTER **
 ** ./src/components/requireLogin.js
 **/